var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRvn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#384182"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.34375 15.1875L7.37888 5.74369L8.52075 12.8312L5.34375 15.1875ZM7.41825 5.68969L10.5103 12.8385L8.57362 12.8048L7.41825 5.68969ZM7.46438 5.63569L11.5144 6.21112L10.5761 12.8385L7.46438 5.63569ZM10.6481 12.7367L11.5611 6.27187L12.1584 7.03013L10.6481 12.7367ZM11.5014 6.14981L7.54931 5.58787L11.1077 4.41675L11.5014 6.14981ZM7.53019 5.52713L9.95231 3.84806L11.1077 4.356L7.53019 5.52713ZM7.47056 5.50688L7.93744 4.61306L9.91294 3.82106L7.47056 5.50688ZM7.93744 4.57313L8.16019 3.87562L9.78806 3.82106L7.93744 4.57256V4.57313ZM8.14725 3.82106L8.67206 3.25913L9.80156 3.76706L8.14725 3.82106ZM8.70525 3.22538L9.49275 2.8395L10.5109 4.03087L8.70525 3.22538ZM9.60469 2.88675L10.7797 3.40144L10.5694 4.03762L9.60469 2.88675ZM10.6088 4.05788L10.8253 3.40819L11.088 4.302L10.6088 4.05788ZM9.51919 2.8125H10.3792L10.8051 3.28613C10.809 3.2907 10.8113 3.29646 10.8116 3.3025C10.8119 3.30853 10.8101 3.31449 10.8066 3.31941C10.8031 3.32433 10.7981 3.32794 10.7923 3.32966C10.7865 3.33137 10.7803 3.3311 10.7747 3.32888L9.51919 2.8125ZM10.8782 3.35419L12.6276 3.84244C12.6364 3.84457 12.6443 3.84961 12.6499 3.85675C12.6555 3.86389 12.6586 3.87272 12.6586 3.88181C12.6586 3.89091 12.6555 3.89973 12.6499 3.90688C12.6443 3.91402 12.6364 3.91906 12.6276 3.92119L11.1409 4.329L10.8782 3.35419Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32871"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRvn);
export default __webpack_public_path__ + "static/media/rvn.64a84a08d9498a4ee5031dbe99b1b630.svg";
export { ForwardRef as ReactComponent };